/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrgSpecAdminUpdate
 */
export interface OrgSpecAdminUpdate {
    /**
     * 
     * @type {string}
     * @memberof OrgSpecAdminUpdate
     */
    org_code: string;
    /**
     * 
     * @type {string}
     * @memberof OrgSpecAdminUpdate
     */
    spec_name: string;
    /**
     * 
     * @type {number}
     * @memberof OrgSpecAdminUpdate
     */
    arc_flash_alerts: number;
    /**
     * 
     * @type {number}
     * @memberof OrgSpecAdminUpdate
     */
    fall_alerts: number;
    /**
     * 
     * @type {number}
     * @memberof OrgSpecAdminUpdate
     */
    impact_alerts: number;
    /**
     * 
     * @type {number}
     * @memberof OrgSpecAdminUpdate
     */
    current_sensitivity: number;
    /**
     * 
     * @type {number}
     * @memberof OrgSpecAdminUpdate
     */
    voltage_range: number;
    /**
     * 
     * @type {number}
     * @memberof OrgSpecAdminUpdate
     */
    voltage_sensitivity: number;
    /**
     * 
     * @type {string}
     * @memberof OrgSpecAdminUpdate
     */
    org_spec_azure_id: string;
}

/**
 * Check if a given object implements the OrgSpecAdminUpdate interface.
 */
export function instanceOfOrgSpecAdminUpdate(value: object): value is OrgSpecAdminUpdate {
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('spec_name' in value) || value['spec_name'] === undefined) return false;
    if (!('arc_flash_alerts' in value) || value['arc_flash_alerts'] === undefined) return false;
    if (!('fall_alerts' in value) || value['fall_alerts'] === undefined) return false;
    if (!('impact_alerts' in value) || value['impact_alerts'] === undefined) return false;
    if (!('current_sensitivity' in value) || value['current_sensitivity'] === undefined) return false;
    if (!('voltage_range' in value) || value['voltage_range'] === undefined) return false;
    if (!('voltage_sensitivity' in value) || value['voltage_sensitivity'] === undefined) return false;
    if (!('org_spec_azure_id' in value) || value['org_spec_azure_id'] === undefined) return false;
    return true;
}

export function OrgSpecAdminUpdateFromJSON(json: any): OrgSpecAdminUpdate {
    return OrgSpecAdminUpdateFromJSONTyped(json, false);
}

export function OrgSpecAdminUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrgSpecAdminUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'org_code': json['org_code'],
        'spec_name': json['spec_name'],
        'arc_flash_alerts': json['arc_flash_alerts'],
        'fall_alerts': json['fall_alerts'],
        'impact_alerts': json['impact_alerts'],
        'current_sensitivity': json['current_sensitivity'],
        'voltage_range': json['voltage_range'],
        'voltage_sensitivity': json['voltage_sensitivity'],
        'org_spec_azure_id': json['org_spec_azure_id'],
    };
}

export function OrgSpecAdminUpdateToJSON(json: any): OrgSpecAdminUpdate {
    return OrgSpecAdminUpdateToJSONTyped(json, false);
}

export function OrgSpecAdminUpdateToJSONTyped(value?: OrgSpecAdminUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'org_code': value['org_code'],
        'spec_name': value['spec_name'],
        'arc_flash_alerts': value['arc_flash_alerts'],
        'fall_alerts': value['fall_alerts'],
        'impact_alerts': value['impact_alerts'],
        'current_sensitivity': value['current_sensitivity'],
        'voltage_range': value['voltage_range'],
        'voltage_sensitivity': value['voltage_sensitivity'],
        'org_spec_azure_id': value['org_spec_azure_id'],
    };
}

